<div class="relative inline-block">
  <!-- Export Button -->
  <button
    type="button"
    (click)="showOptions()"
    class="flex items-center gap-2 px-3 py-1.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 hover:border-slate-300 dark:border-slate-600 transition-all duration-200 cursor-pointer group"
  >
    <ng-content>
      <svg class="w-3.5 h-3.5 text-slate-400 group-hover:text-slate-600 dark:text-slate-400 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
      </svg>
      <span class="text-xs font-semibold text-slate-600 dark:text-slate-400 group-hover:text-slate-800 dark:text-slate-100 transition-colors">Export</span>
      <svg
        class="w-3 h-3 text-slate-400 transition-all"
        [class.rotate-180]="isShowOptions"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
      </svg>
    </ng-content>
  </button>

  <!-- Export Options Dropdown -->
  @if (isShowOptions) {
    <div class="absolute right-0 top-full mt-2 w-56 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg shadow-xl overflow-hidden z-50 animate-[slideDown_0.2s_ease]">
      @for (type of exportTypes; track $index) {
        <button
          type="button"
          (click)="export(type)"
          class="w-full flex items-center gap-3 px-4 py-3 hover:bg-primary-50 transition-colors border-b border-gray-100 last:border-b-0 group"
        >
          <!-- Icon based on type -->
          @if (type === 'Excel') {
            <div class="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <svg class="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 24 24">
                <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18.5,9L13,3.5V9H18.5M8.93,12.22H10V16.3L11.57,14.73L13.37,17.2L12.42,18.03L11.53,16.93L10.07,18.39L8.93,17.25V12.22M14.93,12.22H17.5V13.35H14.93V12.22M14.93,14.27H17.5V15.4H14.93V14.27M14.93,16.32H17.5V17.45H14.93V16.32Z"></path>
              </svg>
            </div>
          }
          @if (type === 'PDF') {
            <div class="w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <svg class="w-5 h-5 text-red-600" fill="currentColor" viewBox="0 0 24 24">
                <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18.5,9L13,3.5V9H18.5M10.5,11.5C10.5,10.67 11.17,10 12,10C12.83,10 13.5,10.67 13.5,11.5V12.5C13.5,13.33 12.83,14 12,14C11.17,14 10.5,13.33 10.5,12.5V11.5M7,13V10H8.5V13H10V15H7V13M14,15V10H15.5C16.33,10 17,10.67 17,11.5V13.5C17,14.33 16.33,15 15.5,15H14Z"></path>
              </svg>
            </div>
          }
          @if (type === 'CSV') {
            <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <svg class="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18.5,9L13,3.5V9H18.5M8,13V15H16V13H8M8,17V19H13V17H8Z"></path>
              </svg>
            </div>
          }
          
          <!-- Text -->
          <div class="flex-1 text-left">
            <p class="text-sm font-medium text-gray-900 dark:text-white group-hover:text-primary-500 transition-colors">
              {{ _image[type].text }}
            </p>
            <p class="text-xs text-gray-500 dark:text-slate-400 mt-0.5">
              @if (type === 'Excel') {
                Download as .xlsx
              }
              @if (type === 'PDF') {
                Download as .pdf
              }
              @if (type === 'CSV') {
                Download as .csv
              }
            </p>
          </div>

          <!-- Arrow -->
          <svg class="w-4 h-4 text-gray-400 group-hover:text-primary-500 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
          </svg>
        </button>
      }
    </div>
  }
</div>
